import { useEffect } from 'react';
import { setUserCurrentInfo } from 'feature/auth/store';
import { useGetCurrentUserInfoQuery } from 'feature/users/api/users-api';
import { useAppDispatch } from './use-app-dispatch';
import { useAppSelector } from './use-app-selector';

const useSetCurrentUserInfoData = () => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const {
    isSuccess: isCurrentUserInfoSuccess,
    data: currentUserInfoData,
    isError: isCurrentUserInfoError,
  } = useGetCurrentUserInfoQuery(undefined, {
    skip: !isAuthenticated,
  });

  useEffect(() => {
    if (isCurrentUserInfoSuccess && currentUserInfoData) {
      dispatch(setUserCurrentInfo(currentUserInfoData));
    }
  }, [dispatch, isCurrentUserInfoSuccess, currentUserInfoData]);

  useEffect(() => {
    if (isCurrentUserInfoError) {
      dispatch(setUserCurrentInfo(undefined));
    }
  }, [dispatch, isCurrentUserInfoError]);
};

export default useSetCurrentUserInfoData;
